import React from "react";

const Sevices = () => {
  return (
    <div>
      <h3 style={{color: "#002244"}}>Core Services</h3>
      <p>
        We offer a comprehensive range of services tailored to meet diverse
        client needs, including:
      </p>
      <ul>
        <li>
          <h5>Full-Scale Construction</h5>
          <p>
            From ground-up construction of new buildings to major structural
            renovations, we handle all aspects of the build process.
          </p>
        </li>
        <li>
          <h5>Interior Design & Engineering</h5>
          <p>
            Our team creates bespoke designs, develops detailed space plans, and
            engineers layouts that optimize functionality and flow.
          </p>
        </li>
        <li>
          <h5>Project Management</h5>
          <p>
            We provide end-to-end project management, overseeing schedules,
            budgets, and subcontractor coordination to ensure a smooth and
            efficient project.
          </p>
        </li>
        <li>
          <h5>Renovation & Remodeling</h5>
          <p>
            Specializing in transforming existing spaces, we provide services
            for kitchen and bathroom remodels, office retrofits, and
            comprehensive residential and commercial updates.
          </p>
        </li>
        <li>
          <h5>Interior Fit-Outs</h5>
          <p>
            We manage the installation of all interior elements, including
            flooring, lighting, custom millwork, cabinetry, and furniture,
            fixtures, and equipment (FF&E).
          </p>
        </li>
        <li>
          <h5>Sustainable & Green Building</h5>
          <p>
            We are committed to incorporating eco-friendly materials and
            energy-efficient practices to create sustainable, long-lasting
            spaces.
          </p>
        </li>
      </ul>
      <h3 style={{color: "#002244"}}>Our Experience & Portfolio</h3>
      <p>
        With 20 years of industry experience, we have successfully completed a
        wide array of projects across multiple sectors. Our portfolio showcases
        our ability to handle complex challenges and deliver diverse aesthetic
        styles. Notable projects include:
      </p>
      <ul>
        <li>
          <b>Residential:</b> Luxury villas, modern apartments, and full-home
          renovations.
        </li>
        <li>
          <b>Commercial: </b> Corporate offices, co-working spaces, and retail
          storefronts.
        </li>
        <li>
          <b>Hospitality: </b> Restaurants, cafes, and boutique hotels.
        </li>
      </ul>
      <p>
        Each project is a testament to our team's skill, dedication, and collaborative spirit. We invite potential clients to review our portfolio to see the quality and scope of our work firsthand.
      </p>
    </div>
  );
};

export default Sevices;
